import { setCookie } from 'cookies-next';
import { useEffect } from 'react';

export const useFindOptionsEffect = (searchValue, handleFindOptions, setOptions, setLoading, nomeCampo) => {
  useEffect(() => {
    if (searchValue?.length > 2) {
      setLoading(true);

      const timer = setTimeout(() => {
        if(handleFindOptions) {         
          handleFindOptions(searchValue).then(resultOptions => {
            setCookie(`electy-server@${nomeCampo}`, resultOptions)
            setOptions(resultOptions);
          }).catch((err) => {
            setOptions([]);
          }).finally(() => {
            setLoading(false);
          });
        }
      }, 1000);

      return () => {
        setLoading(false);
        clearTimeout(timer);
      };
    }
  }, [searchValue]);
};